export enum SkeletonLoadingTheme {
  Theme1 = 'theme1',
  Theme2 = 'theme2',
  Theme3 = 'theme3',
  Theme4 = 'theme4',
}

export interface SkeletonLoadingTypeProps {
  width?: string;
  height?: string;
  className?: string;
  theme?: SkeletonLoadingTheme;
}
